<script setup lang="ts">
import { computed } from 'vue'

import {
  Button,
  Tooltip,
  useBreakpoints,
  useSpaceEventHandler,
  type ButtonSize,
} from '@collector/shared-ui'
import { useEventSettings } from '@desktop/views/Relation/composables'

import { useBlockades } from '../../../../composables'

interface Props {
  size?: ButtonSize
}

const props = defineProps<Props>()

// composables
const { eventSettings, updateEventSettings } = useEventSettings()
const { isPitchBlocked } = useBlockades()
const { breakpoints } = useBreakpoints()

// computed
const buttonSize = computed(
  () => props.size ?? (breakpoints['2md'].value ? 'md' : 'xs'),
)

// methods
function changePossession(): void {
  if (isPitchBlocked()) {
    return
  }

  updateEventSettings({
    teamSidePossession:
      eventSettings.value.teamSidePossession === 'home' ? 'away' : 'home',
  })
}

// init
useSpaceEventHandler(changePossession)
</script>

<template>
  <Tooltip
    lazy
    placement="bottom"
  >
    <template #tooltip>keyboard shortcut: Space</template>
    <Button
      class="enabled:hover:bg-error-6/60 text-neutral-dark-0 bg-neutral-light-7 border-neutral-light-0 w-full px-7! font-bold enabled:hover:border-transparent"
      :size="buttonSize"
      :disabled="isPitchBlocked()"
      @click="changePossession"
    >
      Change possession
    </Button>
  </Tooltip>
</template>
